import dynamic from 'next/dynamic';
import styles from './IppicaQuoteFinaliBox.module.scss';

export type IppicaQuoteFinaliBoxProps = {
  title?: string;
  esitoList: {
    esito?: string | null;
    quota: string | number;
  }[];
  hasMarginBottom?: boolean;
  containerClassName?: string;
};

export const DynamicIppicaQuoteFinaliBox = dynamic(() =>
  import('features/ippica/components/ippicaQuote/ippicaQuoteFinaliBox').then((mod) => mod.IppicaQuoteFinaliBox)
);
export const IppicaQuoteFinaliBox = ({
  title,
  esitoList,
  hasMarginBottom,
  containerClassName,
}: IppicaQuoteFinaliBoxProps) => {
  return (
    <div
      className={`${styles.container} ${containerClassName ? containerClassName : ''} ${
        hasMarginBottom ? styles.withMarginBottom : ''
      }`}
    >
      {title && <p className={styles.title}>{title}</p>}
      {esitoList &&
        esitoList.map((singleQuota, index) => {
          const { esito, quota } = singleQuota;
          return (
            <p key={esito + '_' + index} className={`${styles.row} ${!esito ? styles.centered : ''}`}>
              {esito && <span className={styles.text}>{esito}</span>}
              <span className={styles.quota}>{quota}</span>
            </p>
          );
        })}
    </div>
  );
};
